/* eslint-disable */
import axios from "axios";
import "/src/assets/css/animate.css";
import "/src/assets/css/style.css";
import { useStore } from "vuex";
import moment from "moment";
import Chart from "chart.js";
import jwt_decode from "jwt-decode";
import store from "@/store";
import VPagination from "@hennge/vue3-pagination";
import customModal from "../customModal/customModal.vue";
import { version } from "vuex/dist/vuex.cjs.js";
import VuePdfEmbed from 'vue-pdf-embed';
import showformmodel from "../showformmodel/showformmodel.vue"

export default {
  name: "subjectcasebook",

  components: {
  
    customModal,

   
    VPagination,
    
    VuePdfEmbed,
  
    showformmodel
  },

  props: {
    subjectId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      selectedclass: "selectedsubjectmenu subject-profile-sidebar__link",
      nonselectedclass: "subject-profile-sidebar__link",
      defaultdate: "",
       dynamicColumns: [], 
      SortOrder:0,
      setshowFormModal: false,
      SortProperty:"",
      selectedFormName: '',
      currentform: "",
      tilevalues: {
        totalAEs: 0,
        grade3PlusAEs: 0,
        saEs: 0,
        susaRs: 0
      },
      templateList: [],
      showSidePopup: [],
 
      defaultTime: "",
      subjectid: "",
      patient: null,
      baseapi: process.env.VUE_APP_Service_URL,
      patientId: "",
      users: [],
      SortProperty: "CreatedAt",
      pageindex: 1,
      
      templateForms: [], 
      templateFormsLoading: false,
      selectedTemplateId: null,
      pagesize: 10,
      SortOrder: 1,
      isFormLoading: false,
      patientLogin: {},
      formsTree: [],              
      selectedFormId: null,     
      showFormsLoading: false,
    };
  },

  watch: {
    selectedmenu(newVal) {
      if (newVal === 'Forms' && this.formsTree.length === 0) {
        this.getFormsTree();
      }
    }
  },

  computed: {
    
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.previousRoute = from.fullPath;
    });
  },

  beforeMount() {
    store.dispatch("setNavbar", true);
    const pageWrapper = document.getElementById("page-wrapper");
    if (pageWrapper) {
      pageWrapper.style.width = "100%";
      pageWrapper.style.minHeight = "100vh";
      pageWrapper.style.height = "100vh";
    }
    const getselectedmenu = localStorage.getItem("selectedmenu");
    if (getselectedmenu && getselectedmenu != "") {
      this.selectedmenu = getselectedmenu;
    }
    if (this.$route.query.tab === 'document') {
      this.selectedmenu = 'Document';
    }
    if (this.$route.query.tab === 'forms') {
      this.selectedmenu = 'Forms';
    }
  },

  mounted() {
    this.defaultdate = localStorage.getItem("dateformat");
    this.defaultTime = localStorage.getItem("timeformat");
    this.getPatientById();
    if (this.selectedmenu === 'Forms') {
      this.getFormsTree();
    }
    window.addEventListener("eConsentUpdated", this._eConsentHandler);
  },

  beforeUnmount() {
    localStorage.setItem("selectedmenu", this.selectedmenu)
    window.removeEventListener("eConsentUpdated", this._eConsentHandler);
    store.dispatch("setNavbar", true);
    const pageWrapper = document.getElementById("page-wrapper");
    if (pageWrapper) {
      pageWrapper.style.removeProperty("width");
      pageWrapper.style.removeProperty("min-height");
      pageWrapper.style.removeProperty("height");
    }
  },

  methods: {
    async getPatientloginInfo() {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseapi}/account-core/user/subjectbyid?subjectId=${this.patient.patientId}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.patientLogin = res.data || {};
          if (this.patientLogin.emailID) {
            this.inviteEmail = this.patientLogin.emailID;
          }
        })
        .catch((err) => {
          console.log(" error get patient login", err);
          this.patientLogin = {};
        });
    },
async viewforms(item) {
    const formId = item.FormId || item.formId || item.formID || item.id;
    if (!formId) {
        console.warn("Unable to open form: missing form id", item);
        return;
    }
    this.currentform = formId;
    this.setshowFormModal = true;
},
// async viewforms(item) {
//     const formId = item.FormId || item.formId || item.formID || item.id;
//     const patientId = item.patientId || item.PatientId || item.subId || item.subjectId || this.patient?.patientId || this.subjectId;

//     if (!formId) {
//         console.warn("Unable to open form: missing form id", item);
//         return;
//     }

//     await store.dispatch("setFieldName", " ");
//     if (patientId) {
//         localStorage.setItem("patientId", patientId);
//     }
//     await this.$router.push({
//         name: "showform",
//         params: {
//             closeoption: "subjectcasebook",   
//             formsesid: formId,
//             fromArchive: "false",
//         },
//         query: {
//             subjectId: patientId, 
//         },
//     });
// },

    closeformModal() {
      this.setshowFormModal = false;
    },

    decideclass(menuitem) {
      if (this.selectedmenu === menuitem) {
        return this.selectedclass;
      }
      else {
        return this.nonselectedclass;
      }
    },
    
    async getPatientById() {
      const idtoken = store.getters.getIdToken;
      try {
        const response = await axios.get(
          `${this.baseapi}/management/patient/getpatientbyid/${this.subjectId}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        this.patient = response.data;
        console.log("Patient Data:", this.patient);
      
      } catch (error) {
        console.error("Error fetching patient:", error);
      }
    },
   
    formatDate(dateString) {
      if (!dateString) return 'Not set';
      try {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        });
      } catch {
        return 'Invalid date';
      }
    },
    formatTime(dateString) {
      if (!dateString) return '';
      try {
        const date = new Date(dateString);
        return date.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: true
        });
      } catch {
        return '';
      }
    },
    getBadgeClass(status) {
      switch (status) {
        case 'Consented':
          return 'badge-success';
        case 'Awaiting consent':
          return 'badge-primary';
        case 'Dissented':
          return 'badge-danger';
        default:
          return 'badge-secondary';
      }
    },
    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleDateString();
    },
    async getSelectedTemplate(tempid) {
      const selectedTemplate = this.eConsentTemplates.find(
        (template) => template.templateId === tempid
      );
      this.selectedFormName = selectedTemplate?.templateName || "";
      return selectedTemplate || null;
    },
    async getdata(tempid) {
      return await this.getSelectedTemplate(tempid || this.selectedTemplateId);
    },
    formatdatetime(data) {
      if (data) {
        return moment(data).format(this.defaultdate)
      }
    },

    formatDateForInput(date) {
      if (!date) return null;
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    toISOString(date) {
      return date ? new Date(date).toISOString() : null;
    },
    
    async getSubjectDocuments() {
      const idtoken = store.getters.getIdToken;
      this.showDocumentLoading = true;
      try {
        const response = await axios.get(
          `${this.baseapi}/etmf/document/getdocumentsbysubject?subjectId=${this.subjectId}&studyId=${store.getters.getStudyIs}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        this.documentList = response.data || [];
      } catch (error) {
        console.error("Error fetching documents:", error);
        this.documentList = [];
      } finally {
        this.showDocumentLoading = false;
      }
    },
   
    formatDate(iso) {
      if (!iso) return "-";
      const d = new Date(iso);
      return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
    },
    closePage() {
      this.$router.back();
    },
buildFormsTree(scheduleData) {
  const templateMap = new Map();
  scheduleData.forEach(item => {
    if (!item.templateId || !item.templateName) return;
    if (!templateMap.has(item.templateId)) {
      templateMap.set(item.templateId, {
        templateId: item.templateId,
        templateName: item.templateName,
        count: 0,
        formId: null,            
      });
    }
    const entry = templateMap.get(item.templateId);
    entry.count += 1;
    if (item.formId && !entry.formId) {
      entry.formId = item.formId;
    }
  });
  return Array.from(templateMap.values())
    .sort((a, b) => a.templateName.localeCompare(b.templateName));
},
    setselectedmenu(menuitem) {
      this.selectedmenu = menuitem;
      if (menuitem === 'Document') {
        this.getDocuments();
      } else if (menuitem === 'Forms') {
        this.getFormsTree();
      }
    },
async getFormsTree() {
  const idtoken = store.getters.getIdToken;
  const studyId = store.getters.getStudyIs;
  this.formsTree = [];
  if (!studyId) return;
  this.showFormsLoading = true;
  try {
    const response = await axios.get(
      `${this.baseapi}/forms/template/listtemplate?IsPrivileged=true&StudyID=${studyId}&Status=Approved&pageindex=1&pagesize=1000`,
      {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
      }
    );
    this.formsTree = response.data.results || [];
  } catch (error) {
    console.error("Error fetching forms tree:", error);
    this.formsTree = [];
  } finally {
    this.showFormsLoading = false;
  }
},
async fetchTemplateForms(templateId) {
  const idtoken = store.getters.getIdToken;
  const subjectId = this.patient?.patientId || this.subjectId;
  if (!templateId || !subjectId) {
    this.templateForms = [];
    this.dynamicColumns = [];
    return;
  }
  this.templateFormsLoading = true;
  try {
    const response = await axios.get(
      `${this.baseapi}/forms/forms/getformswithfields`,
      {
        params: {
          templateId: templateId,
          subjectId: subjectId,
        },
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
      }
    );
    this.templateForms = response.data || [];

    if (this.templateForms.length > 0) {
      const first = this.templateForms[0];
      const exclude = ['FormId','FormName', 'CreatedUserId',];
      let allKeys = Object.keys(first).filter(key => !exclude.includes(key));
      this.dynamicColumns = allKeys.slice(0, 8);
    } else {
      this.dynamicColumns = [];
    }
  } catch (error) {
    console.error("Error fetching template forms:", error);
    this.templateForms = [];
    this.dynamicColumns = [];
  } finally {
    this.templateFormsLoading = false;
  }
},

  getStatusClass(status) {
    if (!status) return 'badge badge-secondary';
    const lower = status.toLowerCase();
    if (lower === 'completed') return 'badge badge-success';
    if (lower === 'in progress') return 'badge badge-warning';
    if (lower === 'new') return 'badge badge-secondary';
    if (lower === 'saved') return 'badge badge-primary';
    return 'badge badge-secondary';
  },
selectTemplate(tpl) {
  this.selectedTemplateId = tpl.templateId;
  this.fetchTemplateForms(tpl.templateId);
},
selectForm(tpl) {
  if (!tpl || !tpl.templateId) {
    console.warn("No template selected");
    return;
  }
  this.selectedTemplateId = tpl.templateId;
  this.selectedFormId = tpl.formId || null;
  this.fetchTemplateForms(tpl.templateId);
},
  }
};